'use strict';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurationEditorHelper } from '../../../curation-editor-helper';

/**
 * @deprecated after using the <gen-dynamic-form-table> infrastructure in <curation-editor-items-container.component>
 */
@Component({
  selector: 'gen-curation-editor-item',
  templateUrl: 'curation-editor-item.component.html',
  styleUrls: ['curation-editor-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CurationEditorItemComponent implements OnInit {
  @Output() itemDeleted: EventEmitter<{ itemDetails: any, itemDeletedRevisionId: string}> = new EventEmitter();
  @Output() validated: EventEmitter<{ elementKey: string, validationStatus: boolean}> = new EventEmitter();
  @Input() formName: string;
  @Input() vertical: boolean = false;
  @Input() readOnly = false;
  @Input() deleted: boolean = false;
  @Input() inlineEdit: boolean = true;
  @Input() approvedMode: boolean = false;
  @Input() revisionId: string;
  @Input() submitted: boolean = false;
  public uniqueButtonName: string;
  public _itemDetails: any;
  public addNewMode: boolean = false;

  @Input() set itemDetails(data) {
    this._itemDetails = data;
    this.addNewMode = this._itemDetails[CurationEditorHelper.INTERNAL_KEY_PARAM_NAME] &&
      this._itemDetails[CurationEditorHelper.INTERNAL_NEW_ITEM_PARAM_NAME];
  }

  get updatedFieldsContext() {
    return this.approvedMode ? null : this.revisionId + '__' + this._itemDetails[CurationEditorHelper.INTERNAL_KEY_PARAM_NAME];
  }

  constructor() { }

  ngOnInit() {
    this.uniqueButtonName = 'AUTO_delete_button_' + this.formName;
  }

  updateForm(form) {
    Object.assign(this._itemDetails, form);

    // Remove empty values
    for (const propName in this._itemDetails) {
      if (this._itemDetails[propName] === null || this._itemDetails[propName] === undefined || this._itemDetails[propName] == '') {
        delete this._itemDetails[propName];
      }
    }
  }

  deleteItem() {
    this.itemDeleted.emit({ itemDetails: this._itemDetails, itemDeletedRevisionId: this.updatedFieldsContext});
  }

  get itemDeletedShowChanged(): boolean {
    const bool: boolean = !this.approvedMode &&
      this._itemDetails['itemDeletedRevisionId'] != undefined &&
      this._itemDetails['itemDeletedRevisionId'] == this.updatedFieldsContext;

    return bool;
  }

  validationEvent(valid: boolean) {
    if ((this._itemDetails['deleted'] && this._itemDetails['deleted'] == true) || this.readOnly) { // do not validate readonly forms
      return;
    }
    this.validated.emit({
      elementKey: this._itemDetails[CurationEditorHelper.INTERNAL_KEY_PARAM_NAME],
      validationStatus: valid
    });
  }
}
